import { render, staticRenderFns } from "./OrderComplete.vue?vue&type=template&id=68962cfb&scoped=true"
import script from "./OrderComplete.vue?vue&type=script&lang=js"
export * from "./OrderComplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68962cfb",
  null
  
)

export default component.exports